import api from '@app/api'

import type { ResponseDto } from '@app/api/dtos'
import type { ProductPricingDto, ManagingTypeDto } from './dtos'
import type {
  PricingConfigData,
  GetProductPricingListParams,
  PostPricingToolsSendData,
  PricingLevelData,
  GetManagingTypes
} from './types'

const URL = '/pricing/'

const DEFAULT_PARAMS = {
  limit: 1500
}

export const getProductPricingList = async (
  params: GetProductPricingListParams
): Promise<ResponseDto<ProductPricingDto>> => {
  const url = `${URL}product-pricing/list/`

  const response = await api.get<ResponseDto<ProductPricingDto>>(url, { params })
  return response.data
}

export const getPricingConfig = async (): Promise<PricingConfigData> => {
  const url = `${URL}config/`

  const response = await api.get<PricingConfigData>(url)
  return response.data
}

export const patchPricingConfig = async (data: PricingConfigData): Promise<void> => {
  const url = `${URL}config/`

  await api.patch<PricingConfigData>(url, data)
}

export const patchPricingLevel = async (data: PricingLevelData): Promise<void> => {
  const url = `${URL}groups/inbound/`

  await api.post<PricingLevelData[]>(url, data)
}

export const getManagingTypes = async (
  params: GetManagingTypes = DEFAULT_PARAMS
): Promise<ResponseDto<ManagingTypeDto>> => {
  const response = await api.get<ResponseDto<ManagingTypeDto>>(`${URL}groups/list/`, { params })
  return response.data
}

export const postPricingToolsSend = async (data: PostPricingToolsSendData): Promise<void> => {
  const url = `${URL}product-pricing/pricing-tools/send/`

  await api.post<Promise<void>>(url, data)
}

export const checkPricingToolsSend = async (data: PostPricingToolsSendData): Promise<void> => {
  const url = `${URL}product-pricing/pricing-tools/send/check/`

  await api.post(url, data)
}
